import { Form, InputNumber, Switch, type FormInstance } from 'antd';
import type { AlertRuleFormValues } from '../policies/alert-rule-form';

/** The causes a tamper rule can watch for: each is a switch, and the silence cause takes a time. At least one must be on. */
export function AlertRuleTamperFields({ form }: { form: FormInstance<AlertRuleFormValues> }) {
  const watchesSilence = Form.useWatch('silentWithIgnitionOn', form);
  const watchesPower = Form.useWatch('onPowerDisconnect', form);
  const watchesPhone = Form.useWatch('phoneMovingWhileSilent', form);
  const hasNoCause = watchesPower === false && watchesSilence === false && watchesPhone === false;

  return (
    <>
      <Form.Item
        name="onPowerDisconnect"
        label="Tracker's power is disconnected"
        valuePropName="checked"
        extra="The tracker itself reports its external power was cut."
      >
        <Switch />
      </Form.Item>
      <Form.Item name="silentWithIgnitionOn" label="Tracker silent while the ignition was on" valuePropName="checked">
        <Switch />
      </Form.Item>
      {watchesSilence && (
        <Form.Item
          name="silentWithIgnitionOnMinutes"
          label="Silent for (minutes)"
          rules={[{ required: true, type: 'number', min: 1, message: 'Enter at least 1 minute' }]}
        >
          <InputNumber min={1} className="w-32" />
        </Form.Item>
      )}
      <Form.Item
        name="phoneMovingWhileSilent"
        label="Driver's phone moving while the tracker is silent"
        valuePropName="checked"
        extra="Uses the same silent time; 10 minutes when the cause above is off."
      >
        <Switch />
      </Form.Item>
      {hasNoCause && (
        <p role="alert" className="mb-4 text-sm text-error">
          Switch on at least one cause.
        </p>
      )}
    </>
  );
}
